// extracted by mini-css-extract-plugin
module.exports = {"contentGrid":"MigrationPage_contentGrid__1vXad"};